import { LibrarySectionId } from '@lib/utils/librarySections';
import classNames from 'classnames';
import css from './LibrarySectionLabel.module.scss';

/**
 * The copy for each section. Lives here rather than with the grouping logic so the store can
 * derive sections without emitting UI text — it deals in ids, this file owns the words.
 *
 * "Other libraries" rather than "All libraries" on purpose — the pinned ones aren't in it.
 */
const SECTION_LABELS: Record<LibrarySectionId, string> = {
  pinned: 'Pinned',
  other: 'Other libraries',
};

/**
 * Group header shared by all three Libraries surfaces (card grid, mobile list, desktop table),
 * so the wording and typography can't drift apart between them.
 *
 * Rendered as a `<span>`, not a heading element: these label sibling blocks of one list rather
 * than opening document sections, and the surfaces that use it put it inside a grid cell, a flex
 * column and a data-grid row respectively — none of which want a heading in the document
 * outline. The uppercasing is visual (`text-transform`), so assistive tech reads the words as
 * written.
 *
 * `className` carries the host's positioning; this owns only the words.
 */
export const LibrarySectionLabel = ({
  id,
  className,
}: {
  id: LibrarySectionId;
  className?: string;
}) => <span className={classNames(css.label, className)}>{SECTION_LABELS[id]}</span>;
